import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ez-complete-enrollment',
  imports: [
    MatButtonModule,
  ],
  templateUrl: './complete-enrollment.component.html',
  styleUrls: ['./complete-enrollment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteEnrollmentComponent implements OnInit {
  hasUnverifiedOptions = false;
  totalSteps = 0;

  readonly #elementRef = inject(ElementRef);

  ngOnInit() {
    const getAttribute = this.#elementRef.nativeElement.getAttribute.bind(this.#elementRef.nativeElement);

    this.hasUnverifiedOptions = getAttribute('has-unverified-options') === 'has-unverified-options';
    this.totalSteps = +getAttribute('total-steps');
  }
}
